import { i18n } from '@/plugins/i18n'

export const wages = [
    {
        key: "0",
        value: i18n.t('gateway.wages.from_payer')
    },
    {
        key: "100",
        value: i18n.t('gateway.wages.from_me')
    },
    {
        key: "50",
        value: i18n.t('gateway.wages.half')
    }
] 